import React, { useState, useEffect } from "react";

function ModelSelector({ agentId, onChange }) {
  const [agents, setAgents] = useState([]);
  const [label, setLabel] = useState("Choose Agent");

  useEffect(() => {
    fetch(`${process.env.REACT_APP_CRM}/ai/agents`)
      .then((res) => res.json())
      .then((result) => {
        setAgents(result.data || []);
      })
      .catch((err) => {
        console.error("Failed to fetch agents", err);
      });
  }, []);

  // Sync label when agentId or agents change
  useEffect(() => {
    if (!agents.length || !agentId) return;

    const match = agents.find(function (agent) {
      return agent.agent_id === agentId;
    });

    if (match) {
      setLabel(match.agent_name);
    }
  }, [agentId, agents]);

  const handleSelect = (agent) => {
    if (onChange) {
      onChange(agent.agent_id);
    }
  };

  return (
    <div className="dropdown">
      <button
        className="dropdown-toggle"
        type="button"
        id="agentDropdown"
        data-toggle="dropdown"
        aria-expanded="true"
      >
        {label} <i className="fa fa-angle-down" />
      </button>

      <ul
        className="dropdown-menu"
        role="menu"
        aria-labelledby="agentDropdown"
      >
        {agents.map(function (agent) {
          return (
            <li
              key={agent.agent_id}
              className={agentId === agent.agent_id ? "active" : ""}
            >
              <a
                href="#"
                role="menuitem"
                tabIndex="-1"
                onClick={function (e) {
                  e.preventDefault();
                  handleSelect(agent);
                }}
              >
                {agent.agent_name}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default ModelSelector;


// WEBPACK FOOTER //
// ./src/components/ai/ModelSelector.js